import { MUITab } from "@abb/arcadia-ui-react"
import { useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../services/api"
import {
  DiMaDetailsHeader,
  DiMaDetailsHeaderProps,
} from "../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../components/DiMaProgress"
import { DeprecatedDeviceGet } from "../../../models/DeprecatedDevice"
import { useHashTab } from "../../../../hooks/useHashTab"
import { DeprecatedDeviceDetails } from "./details_tab/DeprecatedDeviceDetails"

const returnURL = "/deprecated-devices"

export function DeprecatedDeviceContainer() {
  const { deprecatedDeviceId } = useParams()
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [deprecatedDevice, setDeprecatedDevice] = useState<DeprecatedDeviceGet>()

  useEffect(() => {
    if (deprecatedDeviceId) {
      digitalManagerApi
        .get<DeprecatedDeviceGet>(`/deprecatedDevices/${deprecatedDeviceId}`)
        .then((res) => {
          setDeprecatedDevice(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [navigate, deprecatedDeviceId])

  if (!deprecatedDeviceId) {
    return <Navigate to={returnURL} />
  }

  if (!deprecatedDevice) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: deprecatedDevice.deviceSerialNumber,
    label: "Deprecated Device ID",
    subtitle: deprecatedDevice.id,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DiMaDetailsHeader {...detailsHeaderProps} />
      <MUITab
        tabItems={[{ id: "details", label: "Details" }]}
        value={activeTab}
        handleChange={handleTabChange}
      />
      {activeTab === "details" && (
        <DeprecatedDeviceDetails
          deprecatedDevice={deprecatedDevice}
          setDeprecatedDevice={setDeprecatedDevice}
        />
      )}
    </div>
  )
}
